// 导入axios
import axios from 'axios'


const request = axios.create({
	baseURL:'/',
	timeout:5000,
	// 设置超时时间
})

// 添加统一token
request.interceptors.request.use(function (config) {
	// 登录请求不需要token
	if (!config.url.includes('/openApi/faUser/login')) {
		config.headers.Authorization = localStorage.getItem('token');
	}
	config.headers['Content-Type'] = 'application/json'
	return config
})


export default request
